export interface AuthAppConfig {
  key: string;
  name?: string;
  domain?: string;
  useSignup: boolean;
}

export const APPROVED_APPS: Record<string, AuthAppConfig> = {
  cc: {
    key: 'cc',
    name: 'Compassion Causes',
    domain: 'compassioncauses.com',
    useSignup: true,
  },
  volunteer: {
    key: 'volunteer',
    useSignup: true,
  },
};
